import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Login = () => {
  const [mobileNumber, setMobileNumber] = useState('');
  const [otpSent, setOtpSent] = useState(false);
  const [otp, setOtp] = useState('');

  const handleMobileNumberChange = (e) => {
    setMobileNumber(e.target.value);
  };

  const handleSendOtp = () => {
    if (mobileNumber.length === 10) {
      setOtpSent(true);
      alert('OTP has been sent to your mobile number!');
    } else {
      alert('Please enter a valid 10-digit mobile number.');
    }
  };

  const handleOtpChange = (e) => {
    setOtp(e.target.value);
  };

  const handleLogin = () => {
    if (otp === '1234') {
      alert('Logged in successfully!');
    } else {
      alert('Invalid OTP. Please try again.');
    }
  };

  return (
    <div className='flex justify-center mt-10 '>
      <div>
        <img
          src="//dm6g3jbka53hp.cloudfront.net/static-images/login-pet-09042021.jpg"
          alt=""
          className='h-[500px] border-2 hidden sm:block lg:block border-slate-200'
        />
      </div>
      <div className="flex border-2 border-slate-200">
        <div className="mt-[100px] max-w-md p-6 bg-white rounded-lg ">
          <h1 className="text-2xl font-semibold text-center text-gray-700">Log In</h1>
          <div className="mt-10">
            <label
              htmlFor="mobileNumber"
              className="block text-sm font-medium text-gray-600"
            >
              Mobile Number
            </label>
            <div className="flex items-center mt-2">
              <span className="inline-flex items-center px-3 text-gray-500 bg-gray-200 border border-gray-300 rounded-l-md">
                +91
              </span>
              <input
                type="text"
                id="mobileNumber"
                placeholder="Your valid mobile number"
                value={mobileNumber}
                onChange={handleMobileNumberChange}
                className="flex-1 block w-full px-4 py-2 text-gray-700 bg-white border border-gray-300 rounded-r-md focus:outline-none focus:ring focus:ring-blue-200"
              />
            </div>
          </div>
          {!otpSent ? (
            <button
              onClick={handleSendOtp}
              className="w-full px-4 py-2 mt-4 text-white bg-blue-500 rounded-lg hover:bg-blue-600 focus:outline-none focus:ring focus:ring-blue-200"
            >
              Get OTP
            </button>
          ) : (
            <div className="mt-4">
              <label
                htmlFor="otp"
                className="block text-sm font-medium text-gray-600"
              >
                Enter OTP
              </label>
              <input
                type="text"
                id="otp"
                placeholder="Enter OTP"
                value={otp}
                onChange={handleOtpChange}
                className="block w-full px-4 py-2 mt-2 text-gray-700 bg-white border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200"
              />
              <button
                onClick={handleLogin}
                className="w-full px-4 py-2 mt-4 text-white bg-blue-500 rounded-lg hover:bg-blue-600 focus:outline-none focus:ring focus:ring-blue-200"
              >
                Log In
              </button>
            </div>
          )}
          <p className="mt-4 text-sm text-center text-gray-600">
            Don't have an account?{' '}
            <Link to="/signup" className="text-blue-500 hover:underline">
              Sign Up
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;
